<script>
    import { signOut } from "../../Utils/utilFunctions.svelte";

    import {
        showServerDisconnectionModal,
        serverDisconnectionReason,
    } from "../../stores";

    import { NotificationModal } from "./index.svelte";

    const handleDisconnect = () => {
        signOut({ reason: $serverDisconnectionReason });
        $showServerDisconnectionModal = false;
    };
</script>

<NotificationModal
    isModalOpen={$showServerDisconnectionModal}
    title="Disconnected from server"
    showConfirmBtn={false}
    cancelText="LogIn"
    hideCrossButton
    closeModalFunction={handleDisconnect}
    closeModal={handleDisconnect}
>
    <!-- <p>Detail:</p>
    <p class="break-all">
        {$serverDisconnectionReason}
    </p> -->
    <p>Session expired.</p>
</NotificationModal>
